import React from 'react';
import ShowIf from '../show-if/show-if';
import './mutable-list.scss';

export type MutableListItem = {
  render: () => React.ReactFragment;
  remove: () => void;
  automationIdDescription: string;
};

export type MutableListProps = {
  items: MutableListItem[];
  automationIdPrefix: string;
};

export function MutableList({ automationIdPrefix, items }: MutableListProps) {
  const getAutomationId = (automationIdSuffix) => `${automationIdPrefix}_${automationIdSuffix}`;

  return (
    <div className="MutableList" automationid={getAutomationId('Mutable_List_Main')}>
      {items.map((listItem, index) => {
        return (
          <div
            className="item"
            key={index}
            automationid={getAutomationId(
              `Mutable_List_Child_${index}_${listItem.automationIdDescription}`,
            )}
          >
            <div
              automationid={getAutomationId(
                `Mutable_List_Child_${index}_${listItem.automationIdDescription}_Div_Button_Show_Content`,
              )}
            >
              <ShowIf condition={items.length > 1}>
                <div
                  className="delete-button"
                  onClick={() => {
                    listItem.remove();
                  }}
                />
              </ShowIf>
            </div>

            <div>{listItem.render()}</div>
          </div>
        );
      })}
    </div>
  );
}
